var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [_vm._v("蔚青云智慧融媒平台")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }